module.exports = __webpack_public_path__ + "img/topic3-b.95e4ddb7.jpg";